export function clearCpf(cpf: string = '') {
    const cpfCleared = cpf.replace(/[^a-z0-9]/gi, '')
    return cpfCleared
}
